export default async (publisherData, userId, { userRepository }) => {
  return await userRepository.update(publisherData, userId);
};
